import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { filter, take } from 'rxjs';
import { LocaleService } from 'src/app/core/locale/locale.service';
import { selectCatalog } from 'src/app/root-store/catalog-store/selectors';
import { CatalogSettings, CatalogState } from 'src/app/root-store/catalog-store/state';
import { RootState } from 'src/app/root-store/root-state.model';
import { AppUiService } from 'src/app/services/app-ui.service';
import { CustomLabelsService } from 'src/app/services/custom-labels.service';
import { ToHrefPipe } from '../to-href.pipe';

@Component({
  selector: 'app-footer',
  imports: [RouterModule, TranslatePipe, ToHrefPipe],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  public readonly customLabels = inject(CustomLabelsService);
  private readonly appUiService = inject(AppUiService);
  private readonly store = inject<Store<RootState>>(Store);
  private readonly localeService = inject(LocaleService);

  showFooterBubble = this.appUiService.showFooterBubbleSignal;
  settings?: CatalogSettings;
  catalog?: CatalogState;
  currentLang = this.localeService.currentLang;

  @Input() showConditions = true;

  ngOnInit() {
    this.store
      .select(selectCatalog)
      .pipe(
        filter((c) => !!c.id),
        take(1),
      )
      .subscribe((catalog) => {
        this.catalog = catalog;
        this.settings = catalog.settings;
      });
  }

  toggleFooterBubble() {
    this.appUiService.toggleFooterBubble();
  }
}
